<script>
import moment from 'moment'
import { markAsClickedNotification } from '@src/api/notifications'

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moment: moment,
      isOpen: this.notification.status !== 'READ',
    }
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    openNotification({ id, action }) {
      if (!this.isOpen) {
        this.toggleOpen()
        return
      }

      if (this.isActionNotificationsHref({ action })) {
        return
      }

      const redirectUrl = action || this.$router.resolve({ name: 'notifications' }).href
      markAsClickedNotification({ id })
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          window.open(redirectUrl, '_blank')
        })
    },
    isActionNotificationsHref({ action }) {
      return action === window.location.origin + this.$router.resolve({ name: 'notifications' }).href
    },
  },
}
</script>

<template>
  <div
    :class="{
      [$style.notification]: true,
      [$style.notificationUnread]: notification.status !== 'READ',
      'cursor-pointer-hover': !isActionNotificationsHref(notification) || !isOpen,
    }"
    @click="openNotification(notification)">
    <div :class="{ [$style.notificationHeader]: true }">
      <p class="tag-text color-primary-blue">{{ notification.title }}</p>
      <p :class="$style.notificationDate" class="overline-text color-primary-blue">
        {{ moment.unix(notification.createdAt).format('M/D/yyyy').toUpperCase() }}
      </p>
      <div :class="$style.chevronContainer" @click.stop="toggleOpen">
        <BaseIcon class="color-primary-blue" :name="isOpen ? 'chevron-up' : 'chevron-down'"></BaseIcon>
      </div>
    </div>
    <Transition name="slide-y">
      <div v-if="isOpen" :class="$style.notificationBody">
        <p class="overline-text color-primary-blue">{{ notification.message }}</p>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.notification {
  margin-bottom: 4px;
  background: $lightest-gray;
  border: 1px solid $lightest-gray;
  border-radius: 8px;

  &:hover {
    border: 1px solid $light-gray;
  }
}

.notificationUnread {
  border: 1px solid $secondary-orange !important;
}

.notificationHeader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 8px;

  p:first-child {
    flex-grow: 1;
    height: 100%;
  }

  .notificationDate {
    margin-right: 25px;
    margin-left: 5px;
    white-space: nowrap;
  }

  .chevronContainer {
    position: absolute;
    right: 0;
    display: flex;
    width: 30px;
    height: 100%;
    cursor: pointer;

    svg {
      margin: auto;
    }
  }
}

.notificationBody {
  padding: 0 8px 8px 8px;
}
</style>
